import { render, staticRenderFns } from "./ModalPackage.vue?vue&type=template&id=555f431d&"
import script from "./ModalPackage.vue?vue&type=script&lang=js&"
export * from "./ModalPackage.vue?vue&type=script&lang=js&"
import style0 from "./ModalPackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports